export default __webpack_public_path__ + "static/media/home-finance-industries-img-06.6c5de4be.jpg";